<template>
  <div>
    <div class="left">
      <h1>Congratulations</h1>

      <p>
        You found one! That brings your total up to {{ points }}.
        <span v-if="points === 1">Keep up the good work to unlock more animals!</span>
      </p>

      <div class="label label--for-checkbox">
        <label>
          <input type="checkbox" v-model="expertMode">
          Expert Mode
          <br />
          <small>(your cursor won't change when you hover over the cow)</small>
        </label>
      </div>

      <div class="label label--for-select">
        <label>
          Find a
          <select v-model="animal">
            <option :value="animal.key" v-for="animal in unlockedAnimals">
              {{animal.name}}
            </option>
          </select>
        </label>
      </div>

      <small class="tip" v-if="points < ANIMALS[1].pointsRequired">
        Get to <strong>five points</strong> to unlock another animal
      </small>
      <small class="tip" v-if="points >= ANIMALS[1].pointsRequired && points < ANIMALS[2].pointsRequired">
        Get to <strong>fifty points</strong> to unlock the final animal
      </small>
      <small class="tip" v-if="points >= ANIMALS[2].pointsRequired">
        Congratulations, you’ve unlocked them all!
      </small>

      <find-button @click="setPage(PAGE_GAME)">Find a {{ animal }}</find-button>
      <find-social-button network="facebook" />
      <find-social-button network="twitter" />
    </div>
    <div class="right">
      <ins
        class="adsbygoogle"
        style="width:300px;height:250px"
        data-ad-client="ca-pub-3956850377782988"
        data-ad-slot="4677943079"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
  ANIMALS,
  PAGE_GAME,
} from 'constants';
import Button from 'components/Button.vue';
import SocialButton from 'components/SocialButton.vue';

export default {
  components: {
    'find-button': Button,
    'find-social-button': SocialButton,
  },
  data: () => ({
    ANIMALS,
    PAGE_GAME,
  }),
  computed: {
    unlockedAnimals() {
      return ANIMALS.filter(a => !a.pointsRequired || this.points >= a.pointsRequired);
    },
    animal: {
      get() {
        return this.$store.state.animal;
      },
      set(value) {
        this.$store.commit('setAnimal', value);
      },
    },
    expertMode: {
      get() {
        return this.$store.state.expertMode;
      },
      set(value) {
        this.$store.commit('setExpertMode', value);
      },
    },
    ...mapState({
      points: state => state.points,
    }),
  },
  methods: mapActions([
    'setPage',
  ]),
};
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 0;
}

.right {
  display: none;
}

@media screen and (min-width: 800px) {
  .left {
    float: left;
    width: calc(100% - 300px - 1rem);
  }
  .right {
    display: block;
    float: right;
    margin-left: 1rem;
    width: calc(300px);
  }
}

.adsbygoogle {
  display: inline-block;
}

.label {
  &--for-checkbox {
    margin-bottom: 10px;
  }

  &::after {
    clear: both;
    content: '';
    display: table;
  }

  input[type=checkbox],
  label {
      cursor: pointer;
  }

  input[type=checkbox] {
    float: left;
    margin: 3px 10px 15px 0;
  }

  select {
    cursor: pointer;
    font: inherit;
    margin-left: 0.25em;
  }
}

.tip {
  display: block;
  margin: 1em 0;
}
</style>



// WEBPACK FOOTER //
// Congratulations.vue?dae7e582